import { render, staticRenderFns } from "./ReportSelectFieldsLayout.vue?vue&type=template&id=972f2c12&scoped=true&"
import script from "./ReportSelectFieldsLayout.vue?vue&type=script&lang=ts&"
export * from "./ReportSelectFieldsLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972f2c12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
